var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClass,on:{"click":_vm.openPopup}},[_c('Btn',{attrs:{"text":_vm.text,"modifiers":_vm.modifiers.concat(['medium', _vm.network])}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }